import { Component, OnInit, OnDestroy, EventEmitter, ViewChild } from '@angular/core';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SiteService } from 'src/app/_services/site.service';
import { UsersService } from 'src/app/_services/admin/users.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from "ngx-spinner";
import { ErrorUtil } from "src/app/_utilities/error";
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { getMaintenanceDateRange } from "src/app/dashboard/cmms-dashboard/maintenance-cmms/maintenance-date-range.util";
import {UtilServiceService} from "src/app/_services/utilService/util-service.service";
import { forkJoin } from "rxjs";
import { MultiSelectChangeEvent } from 'node_modules/primeng/multiselect/public_api';
import { JO_GENERATION_QUEUE_THRESHOLD } from '../jo-generation-queue.service';

@Component({
  selector: "app-generate-job-planner",
  standalone: false,
  templateUrl: "./generate-job-planner.component.html",
  styleUrl: "./generate-job-planner.component.scss",
})
export class GenerateJobPlannerComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  duration: string = "THIS_MONTH"; // default selected
  minEndDate: Date | null = null;
  maxStartDate: Date | null = null;
  selectedSite: any;
  allSites: any;
  showSite: boolean = false;
  users: any = [];
  frequencyList: any = [
    // {
    //   name: "All Frequencies",
    //   value: "ALL",
    // },
    {
      name: "Daily Jobs",
      value: "DAILY",
    },
    {
      name: "Weekly Jobs",
      value: "WEEKLY",
    },
    {
      name: "Monthly Jobs",
      value: "MONTHLY",
    },
    {
      name: "Quarterly Jobs",
      value: "QUARTERLY",
    },
    {
      name: "Yearly Jobs",
      value: "YEARLY",
    },
  ];
  blockList: any = [];
  levelList: any = [];
  areaList: any = [];
  jobPlannerForm!: FormGroup;
  dateRangeForm!: FormGroup;
  sites: any = [];
  data: any;
  duration_range: any = {
    start: "",
    end: "",
  };
  estimatedJobCount: number = 0;
  generateJOInProgress: boolean = false;
  queueThreshold: number = JO_GENERATION_QUEUE_THRESHOLD;
  generatedJOProcessId: number = 0;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    private siteService: SiteService,
    private usersService: UsersService,
    public modalRef: BsModalRef,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private util: UtilServiceService, private modalServc: BsModalService
  ) {
    super();
    this.jobPlannerForm = new FormGroup({
      frequency: new FormControl(['DAILY', 'WEEKLY', 'MONTHLY', 'QUARTERLY', 'YEARLY'], [Validators.required]),
      site: new FormControl([], [Validators.required]),
      block: new FormControl([], [Validators.required]),
      level: new FormControl([], [Validators.required]),
      area: new FormControl([], [Validators.required]),
      user: new FormControl([]),
    });

    this.dateRangeForm = new FormGroup({
      customRangeStart: new FormControl(""),
      customRangeEnd: new FormControl(""),
    });
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.loadMetaToGenerateJob();
    this.getUsersList();
    this.jobPlannerForm.valueChanges.subscribe((val: any) => {
      //update the count whenever form values changed
      this.getEstimateJobCount();
    });
    let range: any = getMaintenanceDateRange(
      this.duration,
      this.dateRangeForm.get("customRangeStart")?.value,
      this.dateRangeForm.get("customRangeEnd")?.value,
    );
    this.duration_range.start = this.util.formatDateToISOString(range?.start);
    this.duration_range.end = this.util.formatDateToISOString(range?.end);

    this.push(
      this.dateRangeForm.controls["customRangeStart"].valueChanges.subscribe(
        () => this.onDateSelect("start"),
      ),
    );
    this.push(
      this.dateRangeForm.controls["customRangeEnd"].valueChanges.subscribe(
        () => this.onDateSelect("end"),
      ),
    );
  }

  // ============================================================
  // Language Translation
  // ============================================================
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }
  push(obs: any) {
    super.push(obs);
  }

  selectDuration(type: string) {
    this.duration = type;
    if (type !== "customRange") {
      this.dateRangeForm.controls["customRangeStart"].reset();
      this.dateRangeForm.controls["customRangeEnd"].reset();
      this.dateRangeForm.controls["customRangeStart"].clearValidators();
      this.dateRangeForm.controls["customRangeEnd"].clearValidators();
      this.dateRangeForm.controls["customRangeStart"].updateValueAndValidity();
      this.dateRangeForm.controls["customRangeEnd"].updateValueAndValidity();
      this.minEndDate = null;
      this.maxStartDate = null;

      let range: any = getMaintenanceDateRange(
        type,
        this.dateRangeForm.get("customRangeStart")?.value,
        this.dateRangeForm.get("customRangeEnd")?.value,
      );

      this.duration_range.start = this.util.formatDateToISOString(range?.start);
      this.duration_range.end = this.util.formatDateToISOString(range?.end);
      //call this function to get the updated count
      this.getEstimateJobCount();
    } else {
      this.dateRangeForm.controls["customRangeStart"].setValidators([
        Validators.required,
      ]);
      this.dateRangeForm.controls["customRangeEnd"].setValidators([
        Validators.required,
      ]);
      this.dateRangeForm.controls["customRangeStart"].updateValueAndValidity();
      this.dateRangeForm.controls["customRangeEnd"].updateValueAndValidity();
    }
  }

  onDateSelect(dateKind: string) {
    console.log('on date select enetered..')
    this.duration_range.start = this.util.formatDateToISOString(
      this.dateRangeForm.get("customRangeStart")?.value,
    );
    this.duration_range.end = this.util.formatDateToISOString(
      this.dateRangeForm.get("customRangeEnd")?.value,
    );
    
    const startDate = this.dateRangeForm.controls["customRangeStart"].value;
    const endDate = this.dateRangeForm.controls["customRangeEnd"].value;

    if (dateKind == "start") {
      if (!startDate || startDate == "") {
        this.minEndDate = null;
      } else {
        const minDate = new Date(startDate);
        minDate.setDate(minDate.getDate() + 1);
        this.minEndDate = minDate;
      }
    }
    else{
      if (!endDate || endDate == "") {
        this.maxStartDate = null;
      } else {
        const maxDate = new Date(endDate);
        maxDate.setDate(maxDate.getDate() - 1);
        this.maxStartDate = maxDate;
      }

    }

    if (startDate && endDate && startDate != "" && endDate != "") {
      //call this function to get the updated count
      this.getEstimateJobCount();
    }
  }

  // ============================================================
  // Site Lookup
  // ============================================================
  getSite(event: any) {
    const query = event.query.replace(
      /[&\/\\#,+()$~%!.„'":*‚^_¤?<>|@ª{«»§}©®™ ]/g,
      "",
    );

    if (query && query.length > 2) {
      this.push(
        this.siteService.getSitePicklist(query).subscribe((sites: any) => {
          this.allSites = sites;
        }),
      );
    }
  }

  onSiteSelect(valueData: any) {
    const value = valueData.value ? valueData.value : valueData;
    this.selectedSite = value;
    this.jobPlannerForm.patchValue({
      site: this.selectedSite,
    });
    this.showSite = false;
    this.getBlocksList();
  }

  clearSite() {
    this.selectedSite = null;
    this.jobPlannerForm.controls["site"].reset();
    this.jobPlannerForm.controls["site"].updateValueAndValidity();
  }

  getBlocksList() {
    this.spinner.show();
    this.siteService.getBlocksBySite(this.selectedSite?.id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.status == 200) {
          this.blockList = res.body;
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000,
        );
      },
    });
  }

  getLevelList() {
    //getSiteLevelsByBlock
    this.spinner.show();
    this.siteService.getSiteLevelsByBlock(this.selectedSite?.id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.status == 200) {
          this.blockList = res.body;
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000,
        );
      },
    });
  }

  // ============================================================
  // User List
  // ============================================================
  getUsersList() {
    this.push(
      this.usersService.getActiveUsers().subscribe((data: any) => {
        this.users = data;
      }),
    );
  }

  dedupeById(list: any[]) {
    const seen = new Map();
    for (const item of list) {
      seen.set(item.id, item);
    }
    return Array.from(seen.values());
  }

  onLayerChange(event: any, layer: string) {
    const selectedIds: any[] = event.value || [];
    if (layer == "block") {
      this.jobPlannerForm.controls["level"].reset([]);
      this.jobPlannerForm.controls["area"].reset([]);
      this.areaList = [];

      if (!selectedIds.length) {
        this.levelList = [];
        return;
      }

      //load the levels of every selected block
      forkJoin(
        selectedIds.map((blockId) =>
          this.siteService.getSiteLevelsByBlock(blockId),
        ),
      ).subscribe({
        next: (responses: any[]) => {
          this.levelList = this.dedupeById(
            responses
              .filter((res: any) => res.status == 200)
              .flatMap((res: any) => res.body),
          );
        },
        error: (err: any) => {
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      });
    } else if (layer == "level") {
      //load the areas of every selected level
      this.jobPlannerForm.controls["area"].reset([]);

      if (!selectedIds.length) {
        this.areaList = [];
        return;
      }

      forkJoin(
        selectedIds.map((levelId) =>
          this.siteService.getSiteAreasByLevel(levelId),
        ),
      ).subscribe({
        next: (responses: any[]) => {
          this.areaList = this.dedupeById(
            responses
              .filter((res: any) => res.status == 200)
              .flatMap((res: any) => res.body),
          );
        },
        error: (err: any) => {
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      });
    } else {
    }
  }

  loadMetaToGenerateJob(layer?: string,  event?: MultiSelectChangeEvent) {
    let isAdded: boolean;
    if (event?.itemValue !== undefined) {
      if (typeof(event?.itemValue) == "object"){
        isAdded = event.value.includes(event.itemValue.id);
      }
      else{
        isAdded = event.value.includes(event.itemValue);
      }
      //isAdded false means item has been removed from dropdown
    }
    let blockIds: any[] =[];
    let levelIds: any[] = [];
    let siteList: any = this.jobPlannerForm.get("site")?.value;
    this.blockList = [];
    this.levelList = [];
    this.areaList = [];

    if (layer == 'site') {
      this.jobPlannerForm.controls["block"].reset([]);
      this.jobPlannerForm.controls["level"].reset([]);
      this.jobPlannerForm.controls["area"].reset([]);
      console.log(siteList, 'siteList printing..')
      console.log(this.blockList, 'blocklist data printing..')
      console.log(this.levelList, 'levellist data printing..')
      console.log(this.areaList, 'arealist data printing..')

    }
    if (layer == 'block'){
      blockIds = this.jobPlannerForm.get("block")?.value || [];
      this.jobPlannerForm.controls["level"].reset([]);
      this.jobPlannerForm.controls["area"].reset([]);
    }
    if (layer == 'level'){
      levelIds = this.jobPlannerForm.get("level")?.value || [];
      this.jobPlannerForm.controls["area"].reset([]);
    }
    this.siteService
      .getMetaToGenerateJob(this.data.customer.id, this.data.contract.id, this.jobPlannerForm.get("site")?.value, blockIds, levelIds)
      .subscribe({
        next: (res: any) => {
          if (res.status == 200) {
            this.sites = res.body.sites;
            this.blockList = res.body.siteBlocks;
            this.levelList = res.body.siteLevels;
            this.areaList = res.body.siteAreas;
            if (!layer) {
              //this is for initial load ONLY. Patch the form values for first time loading of the form
              this.jobPlannerForm.patchValue({
                block: this.blockList.map((block: any) => block.id),
                level: this.levelList.map((level: any) => level.id),
                area: this.areaList.map((area: any) => area.id),
                site: this.sites.map((site: any) => site.id),
              });
            }
            //load the form values only if layer has been removed. This is to ensure that the dependent fields are updated correctly based on the parent
            if (layer && layer == 'site' && siteList.length && !isAdded){
              this.jobPlannerForm.patchValue({
                block: this.blockList.map((block: any) => block.id),
                level: this.levelList.map((level: any) => level.id),
                area: this.areaList.map((area: any) => area.id),
              });
            }
            else if (layer && layer == 'block' && blockIds.length && !isAdded){
              this.jobPlannerForm.patchValue({
                level: this.levelList.map((level: any) => level.id),
                area: this.areaList.map((area: any) => area.id),
              });
            }
            else if (layer && layer == 'level' && levelIds.length && !isAdded){
              this.jobPlannerForm.patchValue({
                area: this.areaList.map((area: any) => area.id),
              });
            }
          }
        },
        error: (err: any) => {
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      });
  }

  generateJO() {
    if (this.jobPlannerForm.valid && this.dateRangeForm.valid) {
      this.generateJOInProgress = true;
      let frequencyVal: string[] =
        this.jobPlannerForm.get("frequency")?.value || [];
      let payload: any = {
        customerId: this.data.customer.id,
        contractId: this.data.contract.id,
        siteIds: this.jobPlannerForm.get("site")?.value,
        frequencies: frequencyVal.includes("ALL") ? [] : frequencyVal,
        siteBlockIds: this.jobPlannerForm.get("block")?.value,
        siteLevelIds: this.jobPlannerForm.get("level")?.value,
        siteAreaIds: this.jobPlannerForm.get("area")?.value,
        startDateTime: this.duration_range.start,
        endDateTime: this.duration_range.end,
        users: this.jobPlannerForm.get("user")?.value,
      };

      // if (this.estimatedJobCount > JO_GENERATION_QUEUE_THRESHOLD) {
      //   this.generateQueuedJO(payload);
      //   return;
      // }

      this.spinner.show();
      this.siteService.generateJobOrder(payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.generateJOInProgress = false;
          console.log(res, 'response from generate api')
          if (res.status == 200) {
            this.errorUtil.setErrorMessage(
              200,
              "Job Orders have been generated successfully.",
              null,
              "success",
              2000,
            );
            this.modalServc.setDismissReason("generate_jo_success");
            this.modalRef.hide();
          }
          else if (res.status == 202) {
            //queued jo generation
            this.generatedJOProcessId = res.body.id;
            this.errorUtil.setErrorMessage(
              200,
              "Job Order generation has been queued. You will be notified via email and in-app once it is complete.",
              null,
              "warn",
              3000,
            );
            this.generateQueuedJO();
            let reasonJson: any = {
              reason: "generate_jo_queued",
              data: {processId: this.generatedJOProcessId}
            }
            this.modalServc.setDismissReason(JSON.stringify(reasonJson));
            this.modalRef.hide();


          }
          else{}
        },
        error: (err: any) => {
          this.spinner.hide();
          this.generateJOInProgress = false;
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      });
    } else {
      this.jobPlannerForm.markAllAsTouched();
      this.dateRangeForm.markAllAsTouched();
    }
  }

  //large generations are queued in batches; the planner banner tracks progress
  generateQueuedJO() {
    this.siteService.getGeneratedJobOrdersInfo(this.generatedJOProcessId).subscribe({
      next: (res: any) =>{
        if(res.status == 200){
          //calculate the progess of completion
          console.log(res, 'response from generated jo process printing..')
        }
      },
      error: (err: any) =>{
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000,
        );
      }
    })
  
  }

  getEstimateJobCount() {
    let frequencyVal: string[] =
    this.jobPlannerForm.get("frequency")?.value || [];
    let payload: any = {
      customerId: this.data.customer.id,
      contractId: this.data.contract.id,
      siteIds: this.jobPlannerForm.get("site")?.value,
      frequencies: frequencyVal.includes("ALL") ? [] : frequencyVal,
      siteBlockIds: this.jobPlannerForm.get("block")?.value,
      siteLevelIds: this.jobPlannerForm.get("level")?.value,
      siteAreaIds: this.jobPlannerForm.get("area")?.value,
      startDateTime: this.duration_range.start,
      endDateTime: this.duration_range.end,
      users: this.jobPlannerForm.get("user")?.value,
    };
    this.spinner.show();
    this.siteService.getEstimateJobCount(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.status == 200) {
          this.estimatedJobCount = res.body.newCount;
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        console.log('err printing from GET esitmated job count generated', err)
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000,
        );
      },
    });
  }

  onLayerRemoved(event: any, layer: string) {
    console.log('Layer removed:', layer, 'Event:', event);
  }
}
